import React from 'react';
import PropTypes from 'prop-types'

import {
  Pagination, PaginationItem, PaginationLink,
} from 'reactstrap'

const PageNumber = props => {
  const {basePage, pagesDisplayed} = props
  let list = []
  for (let i=basePage; i < basePage+pagesDisplayed; ++i) {
    list.push(
      <PaginationItem key={`${i}`}>
        <PaginationLink onClick={() => props.page(i)}>{i+1}</PaginationLink>
      </PaginationItem>
    )
  }
  return list
}

PageNumber.propTypes = {
  basePage: PropTypes.number.isRequired,
  pagesDisplayed: PropTypes.number.isRequired,
}

const Pager = props => {
  const {first, prev, more, next, last} = props

  return (
    <Pagination>
      <PaginationItem>
        <PaginationLink first onClick={first}/>
      </PaginationItem>
      <PaginationItem>
        <PaginationLink previous onClick={prev}/>
      </PaginationItem>
      <PageNumber {...props}/>
      <PaginationItem>
        <PaginationLink onClick={more}>...</PaginationLink>
      </PaginationItem>
      <PaginationItem>
        <PaginationLink next onClick={next}/>
      </PaginationItem>
      <PaginationItem>
        <PaginationLink last onClick={last}/>
      </PaginationItem>
    </Pagination>
  )
}

Pager.propTypes = {
  basePage: PropTypes.number.isRequired,
  pagesDisplayed: PropTypes.number.isRequired,
  first: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  last: PropTypes.func.isRequired,
  page: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
}

export default Pager